<template>
  <div class="left-section">
    <div class="pt-5 d-flex flex-column" style="width: 320px;">
      <!-- Profile Card -->
        <v-card class="mb-5 rounded-lg" elevation="2" style="position: relative;">
            <!-- Background Image (shorter height) -->
            <v-img
              src="@/assets/background0.png"
              height="100"
              class="white--text"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
            ></v-img>
            
            <!-- Avatar positioned over the background -->
            <v-avatar 
              size="80" 
              class="avatar-position"
              style="border: 3px solid white;"
            >
              <v-img src="@/assets/default.jpg"></v-img>
            </v-avatar>
            
            <!-- Title positioned below avatar -->
            <v-card-title class="text-h6 d-flex justify-center pt-8 pb-2 name-section">
             {{ appTitle }}
            </v-card-title>
            
            <!-- Buttons -->
            <v-card-actions class="px-4 pt-0 pb-3">
              <v-btn small outlined color="primary" @click="goToProfile">
                <v-icon left>mdi-account</v-icon>
                Profile
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
      <!-- Stories Preview -->
      <!-- <v-card class="mb-5 rounded-lg" elevation="1">
        <v-subheader class="font-weight-bold">Stories</v-subheader>
        <div class="d-flex px-3 pb-3" style="overflow-x: auto;">
          <div v-for="i in 5" :key="i" class="text-center mx-1">
            <v-avatar size="64" class="story-avatar">
              <v-img
                :src="`https://picsum.photos/200/200?random=${i}`"
              ></v-img>
            </v-avatar>
            <div class="caption text-truncate mt-1" style="width: 64px;">User {{i}}</div>
          </div>
        </div>
      </v-card> -->

      <!-- Suggested Posts -->
      <v-card class="mb-5 rounded-lg" elevation="1">
        <v-subheader class="font-weight-bold">Suggested For You</v-subheader>
        <v-img
          src="@/assets/UnauthLeftCard.jpg"
          aspect-ratio="1.5"
        ></v-img>
        <v-card-text class="px-3 py-2">
          <div class="d-flex align-center">
            <v-avatar size="32" class="mr-2">
              <v-img src="https://picsum.photos/200/200?random=10"></v-img>
            </v-avatar>
            <span class="font-weight-medium">travel_enthusiast</span>
            <v-spacer></v-spacer>
            <v-btn small text color="primary" @click="goToProfile">Follow</v-btn>
          </div>
          <div class="mt-2 text-caption grey--text text--darken-1">
            2,345 likes • 12 comments
          </div>
        </v-card-text>
      </v-card>

      <!-- Popular This Week -->
      <v-card class="mb-5 rounded-lg" elevation="1">
        <v-subheader class="font-weight-bold">Popular This Week</v-subheader>
        <div class="d-flex flex-wrap px-2">
          <v-img
            v-for="i in 3" :key="i"
            :src="`https://picsum.photos/300/300?random=${i+20}`"
            width="100px"
            height="100px"
            class="ma-1 rounded"
          ></v-img>
        </div>
        <v-card-actions class="px-3 py-2">
          <v-btn text small color="primary" @click="goToProfile">See All</v-btn>
        </v-card-actions>
      </v-card>

      <!-- Discover More -->
      <!-- <v-card class="rounded-lg" elevation="1" @click="goToProfile">
        <v-subheader class="font-weight-bold">Discover More</v-subheader>
        <v-img
          src="https://images.unsplash.com/photo-1517486808906-6ca8b3f8e1c1?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          aspect-ratio="1.2"
        ></v-img>
        <v-card-text class="px-3 py-2">
          <div class="text-subtitle-1 font-weight-medium">Explore nature</div>
          <div class="text-caption grey--text text--darken-1">
            #outdoors #hiking #nature
          </div>
        </v-card-text>
      </v-card> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  components: {   },
  data() {
    return {};
  },
  computed: {
    ...mapState("auth", {
      profile: "profile",
      sideSection: "sideSection"
    }),
        appTitle() {
      return process.env.VUE_APP_TITLE;
    }
  },
  methods: {
    ...mapActions("auth", {
      getLeftSectionInfo: "getLeftSectionInfo"
    }),
    goToProfile() {
      this.$router.push({ name: "login" });
    },
  
  },
  mounted() {
    this.loading = true;
    // this.getLeftSectionInfo()
    //   .then(() => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     console.log(error.response.data.message);
    //   });
  }
};
</script>

<style scoped>
.left-section {
  max-height: 100vh;
  overflow-y: hidden;
  position: sticky;
  min-height: inherit;
  overflow-x: hidden;
  top: 56px;
  max-width: 430px;
  min-width: 430px;
  width: 430px;
  padding-left: 100px;
}
.left-section:hover {
  overflow-y: auto;
}
.left-section::-webkit-scrollbar {
  width: 6px;
  transition-duration: 0.5s;
}
.left-section::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.05);
  border-radius: 3px;
}
.left-section::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 3px;
}
.left-section::-webkit-scrollbar-thumb:hover {
  background: rgba(0,0,0,0.3);
}

.story-avatar {
  border: 2px solid #ff4081;
  padding: 2px;
}

.caption {
  font-size: 0.7rem;
  color: #616161;
}

.avatar-overlay {
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: -40px; /* Half of avatar size to pull it up */
}

.avatar-elevated {
  border: 3px solid white;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}


.avatar-position {
  position: absolute;
  left: 50%;
  top: 60px; /* Half in/half out of the background */
  transform: translateX(-50%);
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  z-index: 2;
}

.v-card-title {
  padding-top: 40px; /* Space for avatar */
  text-align: center;
      margin-top: 17px;
}

.name-section {
    margin-top: 18px;
}

</style>